<div class="h-full overflow-auto bg-[#151A20] ">
  <div class="flex flex-col sm:flex-row items-center justify-between px-10 pt-10">
    <div class="flex flex-row items-center space-x-2 cursor-pointer" (appClickableDirective)="goBack()">
      <img src="../../../../assets/svg/arrow_back.svg" class="rotate-180" alt="Back" />
      <span class="text-white">{{ "back" | translate }}</span>
    </div>
    @if (isPrimaryUser) {
    <div class="flex flex-row items-center mt-4 sm:mt-0 sm:ml-auto">
      <button class="bg-red-600 text-white px-4 py-2 rounded-3xl flex items-center space-x-2 hover:bg-red-700"
        (appClickableDirective)="deactivatePlant()">
        <span>{{ "deactivate_plant" | translate }}</span>
        <img src="../../../../assets/svg/info-icon.svg" alt="Info" />
      </button>
    </div>
    }
  </div>
  <div class="flex flex-col lg:flex-col md:flex-row sm:flex-row ">
    <div class="pt-6">
      <div
        class="tab_box justify-between items-center lg:flex lg:flex-row md:w-1/8 sm:w-1/10 md:flex-col sm:flex-col shadow-md lg:mx-44 md:pt-8 sm:pt-8 responsive-border">
        <button class="tab_btn sm:p-4 md:p-6 lg:p-0"
          [class.active]="activeTab === plantDetailInformationType.siteDetails"
          (click)="activateTab('siteDetails', $event)">
          {{ "site_detail" | translate }}
        </button>
        <button class="tab_btn" [class.active]="activeTab === plantDetailInformationType.inverterDetails"
          (click)="activateTab('inverterDetails', $event)">
          {{ "inverter_details" | translate }}
        </button>
        @if (
        selectedInverterType !== inverterType.GTI.toString() &&
        selectedInverterType !== inverterType.ON_GRID.toString() &&
        selectedInverterType !== inverterType.ThinkPower.toString() &&
        selectedInverterType !==inverterType.THINKPOWERHESM.toString()
        ) {
        <button class="tab_btn" [class.active]="activeTab === plantDetailInformationType.batteryDetails"
          (click)="activateTab('batteryDetails', $event)">
          {{ "battery_details" | translate }}
        </button>
        }

        @if (
        selectedPlantType !== plantType.NON_SOLAR.toString() &&
        selectedInverterType !== inverterType.NON_SOLAR
        ) {
        <button class="tab_btn" [class.active]="activeTab === plantDetailInformationType.solarPVDetails"
          (click)="activateTab('solarPvDetails', $event)">
          {{ "solar_pv_details" | translate }}
        </button>
        }
        <button class="tab_btn" [class.active]="activeTab === plantDetailInformationType.dataLoggerDetails"
          (click)="activateTab('dataLoggerDetails', $event)">
          {{ "data_logger_details" | translate }}
        </button>
        <button class="tab_btn" [class.active]="activeTab === plantDetailInformationType.connectedUser"
          (click)="activateTab('connectedUser', $event)">
          {{ "connected_user" | translate }}
        </button>
        @if (isPrimaryUser) {
        <button class="tab_btn" [class.active]="activeTab === plantDetailInformationType.downloadReport"
          (click)="activateTab('downloadReport', $event)">
          {{ "download_report" | translate }}
        </button>
        }

        <img src="../../../../assets/svg/download_report.svg" alt="Download Report" class="hidden" />
        <div class="sm:hidden md:hidden lg:block" id="line" #newLine
          [ngStyle]="{ 'width.px': lineWidth, 'left.px': lineLeft }"></div>
      </div>
    </div>
    <div class="flex-1 p-6 lg:mx-44 md:mt-6 sm:mt-6 lg:mt-0">
      <!-- Site Details Tab -->
      <div class="content" [ngClass]="{ active: activeTab === plantDetailInformationType.siteDetails }">
        @if (activeTab === plantDetailInformationType.siteDetails) {
        <form [formGroup]="plantForm">
          <div class="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 gap-4 mt-4">
            <div>
                <label for="plant_name
              " class="sr-only">
  {{ "plant_name" | translate }}
</label>
              <mat-form-field appearance="outline" class="always-white-border">
                <mat-label class="text-white text-xs">{{
                  "plant_name" | translate
                  }}</mat-label>
                <input class="text-white" formControlName="plantName" matInput [id]="'plant_name'" />
              </mat-form-field>
            </div>
            <div>
               <label for="Location
              " class="sr-only">
  {{ "Location" | translate }}
</label>
              <mat-form-field appearance="outline">
                <mat-label class="text-white text-xs">{{
                  "Location" | translate
                  }}</mat-label>
                <input class="text-white" formControlName="location" matInput  [id]="'Location'"/>
              </mat-form-field>
            </div>
            <div>
              <label for="time_zone
              " class="sr-only">
  {{ "time_zone" | translate }}
</label>
              <mat-form-field appearance="outline">

                <mat-label class="text-white text-xs">{{
                  "time_zone" | translate
                  }}</mat-label>
                <input class="text-white" formControlName="timeZone" matInput [id]="'time_zone'"/>
              </mat-form-field>
            </div>
            <div>
               <label for="pin_code" class="sr-only">
  {{ "pin_code" | translate }}
</label>
              <mat-form-field appearance="outline">
                <mat-label class="text-white text-xs">{{
                  "pin_code" | translate
                  }}</mat-label>
                <input formControlName="pinCode" class="text-white" matInput [id]="'pin_code'"/>
              </mat-form-field>
            </div>
            <div>
               <label for="currency" class="sr-only">
  {{ "currency" | translate }}
</label>
              <mat-form-field appearance="outline">
                <mat-label class="text-white text-xs">{{
                  "currency" | translate
                  }}</mat-label>
                <input class="text-white" formControlName="currency" matInput  [id]="'currency'"/>
              </mat-form-field>
            </div>
            <div>
                              <label for="installation_date" class="sr-only">
  {{ "installation_date" | translate }}
</label>
              <mat-form-field appearance="outline">
                <mat-label class="text-white text-xs">{{
                  "installation_date" | translate
                  }}</mat-label>
                <input class="text-white" formControlName="installationDate" matInput  [id]="'installation_date'"/>
              </mat-form-field>
            </div>
            @if (
            enableAverageTariff(selectedInverterType) ||
            selectedPlantType == plantType.NON_SOLAR
            ) {
            <div>
                <label for="average_tariff" class="sr-only">
  {{ "average_tariff" | translate }}
</label>
              <mat-form-field appearance="outline">
                <mat-label class="text-white text-xs">{{
                  "average_tariff" | translate
                  }}</mat-label>
                <input class="text-white" formControlName="averageTariffRate" matInput  [id]="'average_tariff'"/>
              </mat-form-field>
            </div>
            }
            @if (enableGridTariff(selectedInverterType)) {
            <div>
               <label for="grid_feed_tariff" class="sr-only">
  {{ "grid_feed_tariff" | translate }}
</label>
              <mat-form-field appearance="outline">

                <mat-label class="text-white text-xs">{{
                  "grid_feed_tariff" | translate
                  }}</mat-label>
                <input class="text-white" formControlName="gridFeedTariff" matInput [id]="'grid_feed_tariff'" />
              </mat-form-field>
            </div>
            }
            <div>
              <label for="installer_electrician_no" class="sr-only">
  {{ "installer_electrician_no" | translate }}
</label>

              <mat-form-field appearance="outline">
                <mat-label class="text-white text-xs">{{
                  "installer_electrician_no" | translate
                  }}</mat-label>
                <input class="text-white" formControlName="electricianNumber" matInput [id]="'installer_electrician_no'" />
              </mat-form-field>
            </div>
            <div>
<label for="third_party_id" class="sr-only">
  {{ "third_party_id" | translate }}
</label>

              <mat-form-field appearance="outline">
                <mat-label class="text-white text-xs">{{
                  "third_party_id" | translate
                  }}</mat-label>
                <input class="text-white" formControlName="thirdPartyId" matInput  [id]="'third_party_id'"/>
              </mat-form-field>
            </div>
            <div>
              <label for="system_integrator_id" class="sr-only">
  {{ "system_integrator_id" | translate }}
</label>
              <mat-form-field appearance="outline">
                <mat-label class="text-white text-xs">{{
                  "system_integrator_id" | translate
                  }}</mat-label>
                <input class="text-white" formControlName="systemIntegratorId" matInput [id]="'system_integrator_id'" />
              </mat-form-field>
            </div>
            <div>
              <label for="Total Investment" class="sr-only">
  {{ "Total Investment" | translate }}
</label>
              <mat-form-field appearance="outline">
                <mat-label class="text-white text-xs">{{
                  "Total Investment" | translate
                  }}</mat-label>
                <input class="text-white" formControlName="totalInvestment" matInput [id]="'Total Investment'" />
              </mat-form-field>
            </div>
          </div>
          <div class="flex flex-col">
            <label class="block text-white mb-2 opacity-80 text-xs" for="email">
              {{ "types_of_appliance" | translate }}
            </label>
            @if (plantForm.controls["typesOfAppliance"].value.length > 0) {
            <div class="flex sm:w-fit lg:w-1/2 bg-[#1F262E] flex-col rounded-3xl">
              <div class=" lg:w-full grid grid-cols-4 gap-5   py-2  ">
                <div class="grid-cols-1 text-center 
                  ">
                  <span class="text-white text-xs 
                     ">Appliances</span>
                </div>
                <div class="grid-cols-1  text-center ">
                  <span class="text-white text-xs">Power(Watt)</span>
                </div>
                <div class="grid-cols-1  text-center ">
                  <span class="text-white text-xs">Quantity</span>
                </div>
                <div class="grid-cols-1  text-center ">
                  <span class="text-white text-xs">Priority</span>
                </div>
                <div class="hidden grid-cols-1 ">
                  <span class="text-white text-xs">Action</span>
                </div>
              </div>
              <div class="lg:w-full gap-5 grid grid-cols-4 
                 py-3  ">
                @for (
                item of plantForm.controls["typesOfAppliance"].value;
                track $index
                ) {
                <div class="grid-cols-1 text-center
                    ">
                  <span class="text-white text-xs">{{
                    item["appliances"]
                    }}</span>
                </div>
                <div class="grid-cols-1 text-center ">
                  <span class="text-white text-xs">{{
                    item["power"]
                    }}</span>
                </div>
                <div class="grid-cols-1 text-center ">
                  <span class="text-white text-xs">{{
                    item["quantity"]
                    }}</span>
                </div>
                <div class="grid-cols-1 text-center ml-1 ">
                  <span class="text-white text-xs">{{
                    item["priority"]
                    }}</span>
                </div>
                <div class="hidden col-span-1 flex flex-row space-x-4">
                  <app-pen-icon class="text-white text-xs" />
                  <app-trash-icon class="text-white text-xs" />
                </div>
                }
              </div>
            </div>
            }
          </div>
          <div class="flex flex-col mb-5 col-span-1 mt-5">
            <label class="block text-white mb-2 opacity-80 text-xs" for="email">
              {{ "plant_image" | translate }}
            </label>
            <div class="flex flex-col md:flex-row flex-grow md:space-x-2">
              <div
                class="w-[100px] h-[100px] border border-solid border-gray-400 rounded-2xl bg-dark-gray-2 text-white flex justify-center">
                <img [src]="
                      plantForm.controls['plantPhoto'].value
                        ? plantForm.controls['plantPhoto'].value
                        : '../../../../assets/svg/gallery.svg'
                    " alt="Gallery" [ngClass]="{
                      'w-[100px] h-[100px] rounded-2xl':
                        plantForm.controls['plantPhoto'].value,
                      'm-8': !plantForm.controls['plantPhoto'].value
                    }" (appClickableDirective)="
                      plantForm.controls['plantPhoto'].value
                        ? displayImage(plantForm.controls['plantPhoto'].value)
                        : null
                    " />
              </div>
              <div
                class="hidden w-1/4 border border-solid border-gray-400 rounded-2xl py-[8px] px-3 bg-dark-gray-2 text-white flex justify-center items-center text-xs">
                {{ "upload" | translate }}
                <img src="../../../../assets/svg/upload-fota.svg" class="mx-1" alt="Upload" />
              </div>
            </div>
          </div>
        </form>
        }
      </div>
      <div class="content" [ngClass]="{ active: activeTab === plantDetailInformationType.inverterDetails}">
        <!-- Inverter Details Content -->
        @if (activeTab === plantDetailInformationType.inverterDetails) {
        <form [formGroup]="inverterForm">
          <div class="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 gap-4 mt-4">
            <div>
              <label for="model" class="sr-only">
  {{ "model" | translate }}
</label>
              <mat-form-field appearance="outline">
                <mat-label class="text-white text-xs">{{
                  "model" | translate
                  }}</mat-label>
                <input class="text-white" formControlName="model" matInput  [id]="'model'"/>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field appearance="outline">
                  <label for="serial_number
                " class="sr-only"> {{ "serial_number" | translate }}
</label>
                <mat-label class="text-white text-xs">{{
                  "serial_number" | translate
                  }}</mat-label>
                <input class="text-white" formControlName="serialNo" matInput [id]="'serial_number'"
                 />
              </mat-form-field>
            </div>
            <div>
              <mat-form-field appearance="outline">
                <label for="rating
                " class="sr-only"> {{ "rating " | translate }}
</label>
 
                <mat-label class="text-white text-xs">{{
                  "rating" | translate
                  }}</mat-label>
                <input class="text-white" formControlName="rating" matInput [id]="'rating'" />
              </mat-form-field>
            </div>
            <div>
                <label for="date_of_purchase
                " class="sr-only"> {{ "date_of_purchase" | translate }}
</label>
              <mat-form-field appearance="outline">
                <mat-label class="text-white text-xs">{{
                  "date_of_purchase" | translate
                  }}</mat-label>
                <input class="text-white" formControlName="dateOfPurchase" matInput  [id]="'date_of_purchase'"/>
              </mat-form-field>
            </div>
            <div class = "lg:flex"></div>
             <div class = "lg:flex"></div>
            @if(selectedInverterType!=inverterType.ENERTECH_SOLAR.toString() &&
            selectedInverterType!=inverterType.ENERTECH_NON_SOLAR.toString() &&
            selectedInverterType!=inverterType.GTI.toString() &&
            selectedInverterType!=inverterType.ThinkPower.toString() &&
            selectedInverterType!=inverterType.THINKPOWERHESM.toString() && selectedInverterType!=inverterType.ARCTIC_HYBRID.toString()){
            <div>
              <label for="operating_mode
              " class="sr-only"> {{ "operating_mode" | translate }}
</label>
              <mat-form-field appearance="outline">
                
                <mat-label class="text-white text-xs">{{
                  "operating_mode" | translate
                  }}</mat-label>
                <input class="text-white" 
                formControlName="currentSetting" matInput [id]="'operating_mode'" />
              </mat-form-field>
            </div>
            <div></div>
            }
            <div>
              <label class="block text-white mb-2 opacity-80 text-xs" for="email">
                {{ "Inverter Image" | translate }}
              </label>
              <div class="flex flex-col md:flex-row flex-grow md:space-x-2">
                <div
                  class="w-[100px] h-[100px] border border-solid border-gray-400 rounded-2xl bg-dark-gray-2 text-white flex justify-center">
                  <img [src]="
                        inverterForm.controls['inverterPhoto'].value
                          ? inverterForm.controls['inverterPhoto'].value
                          : '../../../../assets/svg/gallery.svg'
                      " alt="Gallery" [ngClass]="{
                        'w-[100px] h-[100px] rounded-2xl':
                          inverterForm.controls['inverterPhoto'].value,
                        'm-8': !inverterForm.controls['inverterPhoto'].value
                      }" (appClickableDirective)="
                        inverterForm.controls['inverterPhoto'].value
                          ? displayImage(
                              inverterForm.controls['inverterPhoto'].value
                            )
                          : null
                      " />
                </div>
                <div
                  class="hidden w-1/4 border border-solid border-gray-400 rounded-2xl py-[8px] px-3 bg-dark-gray-2 text-white flex justify-center items-center text-xs">
                  {{ "upload" | translate }}
                  <img src="../../../../assets/svg/upload-fota.svg" class="mx-1" alt="Upload" />
                </div>
              </div>
            </div>
            <div>
              <label class="block text-white mb-2 opacity-80 text-xs" for="email">
                {{ "Purchase Bill Image" | translate }}
              </label>
              <div class="flex flex-col md:flex-row flex-grow md:space-x-2">
                <div
                  class="w-[100px] h-[100px] border border-solid border-gray-400 rounded-2xl bg-dark-gray-2 text-white flex justify-center">
                  <img [src]="
                        inverterForm.controls['purchaseBillPhoto'].value
                          ? inverterForm.controls['purchaseBillPhoto'].value
                          : '../../../../assets/svg/gallery.svg'
                      " alt="Gallery" [ngClass]="{
                        'w-[100px] h-[100px] rounded-2xl':
                          inverterForm.controls['purchaseBillPhoto'].value,
                        'm-8': !inverterForm.controls['purchaseBillPhoto'].value
                      }" (appClickableDirective)="
                        inverterForm.controls['purchaseBillPhoto'].value
                          ? displayImage(
                              inverterForm.controls['purchaseBillPhoto'].value
                            )
                          : null
                      " />
                </div>
                <div
                  class="hidden w-1/4 border border-solid border-gray-400 rounded-2xl py-[8px] px-3 bg-dark-gray-2 text-white flex justify-center items-center text-xs">
                  {{ "upload" | translate }}
                  <img src="../../../../assets/svg/upload-fota.svg" class="mx-1" alt="Upload" />
                </div>
              </div>
            </div>
            <div class="hidden col-span-6 flex justify-st items-center">
              <div
                class="flex justify-center items-center rounded-xl bg-dark-accent-secondary px-4 py-[5px] text-white">
                <span class="text-xs p-0">{{ "save" | translate }}</span>
              </div>
            </div>
          </div>
        </form>
        }
      </div>
      @if (
      selectedInverterType !== inverterType.GTI.toString() &&
      selectedInverterType !== inverterType.ON_GRID.toString() &&
      selectedInverterType !== inverterType.ThinkPower.toString()&&
      selectedInverterType !==inverterType.THINKPOWERHESM.toString()
      ) {
      <div class="content" [ngClass]="{ active: activeTab === plantDetailInformationType.batteryDetails}">
        <!-- Battery Details Content -->
        @if (activeTab === plantDetailInformationType.batteryDetails ) {
        <form [formGroup]="batteryForm">
          <div class="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 gap-4 mt-4">
            <div>
               <label for ="brand
               " class="sr-only"> {{ "brand"
                | translate }}
</label>
              <mat-form-field appearance="outline">
                <mat-label class="text-white text-xs">{{
                  "brand" | translate
                  }}</mat-label>
                <input class="text-white" formControlName="brand" matInput [id]="'brand'" />
              </mat-form-field>
            </div>
            <div>
              <label for ="serial_number" class="sr-only"> {{ "serial_number " | translate }}
</label>
              <mat-form-field appearance="outline">
                <mat-label class="text-white text-xs">{{
                  "serial_number" | translate
                  }}</mat-label>
                <input class="text-white" formControlName="serialNo" matInput [id]="'serial_number'" />
              </mat-form-field>
            </div>
            <div>
              <mat-form-field appearance="outline">
                <mat-label class="text-white text-xs">{{
                  "type" | translate
                  }}</mat-label>
                <input class="text-white" formControlName="batteryType" matInput [id]="'type'"
                 >
              </mat-form-field>
            </div>
            <div>
              <mat-form-field appearance="outline">
                <mat-label class="text-white text-xs">{{
                  "single_battery_voltage" | translate
                  }}</mat-label>
                <input class="text-white" formControlName="singleBatteryCapacity" matInput [id]="'single_battery_capacity'"
                 />
              </mat-form-field>
            </div>
            <div>
              <mat-form-field appearance="outline">
                <mat-label class="text-white text-xs">{{
                  "no_of_batteries" | translate
                  }}</mat-label>
                <input class="text-white" formControlName="noOfBatteries" matInput [id]="'no of batteries'"
                 />
              </mat-form-field>
            </div>
             <div>
              <mat-form-field appearance="outline">
                <mat-label class="text-white text-xs">{{
                  "single_battery_capacity" | translate
                  }}</mat-label>
                <input class="text-white" formControlName="capacity" matInput [id]="'capacity'"/>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field appearance="outline">
                <mat-label class="text-white text-xs">{{
                  "Total Backup Capacity (Ah)" | translate
                  }}</mat-label>
                <input class="text-white" formControlName="totalBackUpCapacity" matInput [id]="'total Backup Capacity'" />
              </mat-form-field>
            </div>
            <div>
              <mat-form-field appearance="outline">
                 <label for="Date of Purchase" class="sr-only"> {{ "Date of Purchase" | translate }}</label>
                <mat-label class="text-white text-xs">{{
                  "Date of Purchase" | translate
                  }}</mat-label>
                <input class="text-white" formControlName="dateOfPurchase" matInput [id]="'Date of purchase'" />
              </mat-form-field>
            </div>
            <div class="hidden lg:flex "></div>
          
            <div class="flex flex-col mb-5 col-span-1 mt-2">
              <label class="block text-white mb-2 opacity-80 text-xs" for="email">
                {{ "battery_image" | translate }}
              </label>
              <div class="flex flex-col md:flex-row flex-grow md:space-x-2">
                <div
                  class="w-[100px] h-[100px] border border-solid border-gray-400 rounded-2xl bg-dark-gray-2 text-white flex justify-center">
                  <img [src]="
                          batteryForm.controls['batteryPhoto'].value
                            ? batteryForm.controls['batteryPhoto'].value
                            : '../../../../assets/svg/gallery.svg'
                        " alt="Gallery" [ngClass]="{
                          'w-[100px] h-[100px] rounded-2xl':
                            batteryForm.controls['batteryPhoto'].value,
                          'm-8': !batteryForm.controls['batteryPhoto'].value
                        }" (appClickableDirective)="
                          batteryForm.controls['batteryPhoto'].value
                            ? displayImage(
                                batteryForm.controls['batteryPhoto'].value
                              )
                            : null
                        " />
                </div>
                <div
                  class="hidden w-1/4 border border-solid border-gray-400 rounded-2xl py-[8px] px-3 bg-dark-gray-2 text-white flex justify-center items-center text-xs">
                  {{ "upload" | translate }}
                  <img src="../../../../assets/svg/upload-fota.svg" class="mx-1" alt="Upload" />
                </div>
              </div>
            </div>
            <div class="flex flex-col mb-5 col-span-1 mt-2">
              <label class="block text-white mb-2 opacity-80 text-xs" for="email">
                {{ "purchase_bill_image" | translate }}
              </label>
              <div class="flex flex-col md:flex-row flex-grow md:space-x-2">
                <div
                  class="w-[100px] h-[100px] border border-solid border-gray-400 rounded-2xl bg-dark-gray-2 text-white flex justify-center">
                  <img [src]="
                          batteryForm.controls['purchaseBillPhoto'].value
                            ? batteryForm.controls['purchaseBillPhoto'].value
                            : '../../../../assets/svg/gallery.svg'
                        " alt="Gallery" [ngClass]="{
                          'w-[100px] h-[100px] rounded-2xl':
                            batteryForm.controls['purchaseBillPhoto'].value,
                          'm-8':
                            !batteryForm.controls['purchaseBillPhoto'].value
                        }" (appClickableDirective)="
                          batteryForm.controls['purchaseBillPhoto'].value
                            ? displayImage(
                                batteryForm.controls['purchaseBillPhoto'].value
                              )
                            : null
                        " />
                </div>
                <div
                  class="hidden w-1/4 border border-solid border-gray-400 rounded-2xl py-[8px] px-3 bg-dark-gray-2 text-white flex justify-center items-center text-xs">
                  {{ "upload" | translate }}
                  <img src="../../../../assets/svg/upload-fota.svg" class="mx-1" alt="Upload" />
                </div>
              </div>
            </div>
            <div class="hidden col-span-6 flex justify-st items-center">
              <div
                class="flex justify-center items-center rounded-xl bg-dark-accent-secondary px-4 py-[5px] text-white">
                <span class="text-xs p-0">{{ "save" | translate }}</span>
              </div>
            </div>
          </div>
        </form>
        }
      </div>
      }
      @if (
      selectedPlantType !== plantType.NON_SOLAR.toString() &&
      selectedInverterType !== inverterType.NON_SOLAR
      ) {
      <div class="content" [ngClass]="{ active: activeTab === plantDetailInformationType.solarPVDetails}">
        @if (activeTab === plantDetailInformationType.solarPVDetails) {
        <form [formGroup]="solarForm">
          <div class="grid grid-cols-1 lg:grid-cols-2 md:grid-cols-2 gap-4 mt-4 ">
            <div>
              <mat-form-field appearance="outline">
                <mat-label class="text-white text-xs">{{
                  "total_installed_capacity" | translate
                  }}</mat-label>
                <input class="text-white" formControlName="totalInstalledCapacity" matInput [id]="'total_installed_capacity'" />
              </mat-form-field>
            </div>
            <div class="h-16">
              <div class="flex flex-row flex-grow sm:space-x-2 h-10">
                <div class="w-1/2 border border-solid border-white py-[8px] px-2 text-white flex items-center text-xs">
                  <span class="ml-3"> {{ solarForm.get('noofPanelsInParallel')?.value }} &nbsp;{{ 'parallel' | translate
                    }}</span>
                </div>
                <div class="w-1/2 border border-solid border-white py-[8px] px-2 text-white flex  items-center text-xs">
                  <span class="ml-3"> {{ solarForm.get('noofPanelsinSeries')?.value }} &nbsp;{{ 'series' | translate
                    }}</span>
                </div>
              </div>
            </div>

            <div>
              <mat-form-field appearance="outline">
                <mat-label class="text-white text-xs">{{
                  "tilt_angle" | translate
                  }}</mat-label>
                <input class="text-white" formControlName="tiltAngle" matInput  [id]="'tilt_angle'"/>
              </mat-form-field>
            </div>

            <div>
              <mat-form-field appearance="outline">
                <mat-label class="text-white text-xs">{{
                  "Orientation" | translate
                  }}</mat-label>
                <input class="text-white" formControlName="orientation" matInput [id]="'orientation'" />
              </mat-form-field>
            </div>
            <div>
              <div class="flex flex-row space-x-4">
                <label class="block text-white mb-2 opacity-80 text-xs" for="solarTracking">
                  {{ "solar_tracking" | translate }}
                </label>
                <label class="switch">
                  <input type="checkbox" id="solarTracking" formControlName="solarTrackingSystem"
                    aria-label="Solar Tracking" />
                  <span class="slider round"></span>
                </label>
              </div>
              @if (solarData?.solarTrackingSystem) {
              <div class="flex flex-row flex-grow md:space-x-3 items-center">
                <div class="w-1/2">
                  <input id="singleAxis" type="radio" name="axis" [checked]="solarData?.axisVaue === 1" disabled />
                  <label for="singleAxis" class="text-white text-xs">Single Axis</label>
                </div>
                <div class="w-1/2">
                  <input id="dualAxis" type="radio" name="axis" [checked]="solarData?.axisVaue === 2" disabled />
                  <label for="dualAxis" class="text-white text-xs">Dual Axis</label>
                </div>
              </div>}
            </div>

            <div class="flex flex-row space-x-6">
              <div class="flex flex-col">
                <label class="block text-white mb-2 opacity-80 text-xs" for="email">
                  {{ "earthing" | translate }}
                </label>
                <div class="flex flex-row flex-grow space-x-2">
                  <div
                    class="dark:bg-none px-4 py-[3px] dark:text-white rounded-xl border-solid border-[0.5px] border-gray-300 flex items-center space-x-2 cursor-pointer"
                    [ngClass]="{
                          'bg-dark-accent-secondary':
                            solarForm.controls['earthing'].value === true
                        }">
                    <span> {{ "Y" }}</span>
                  </div>
                  <div
                    class="dark:bg-none px-4 py-[3px] dark:text-white rounded-xl border-solid border-[0.5px] border-gray-300 flex items-center space-x-2 cursor-pointer"
                    [ngClass]="{
                          'bg-dark-accent-secondary':
                            solarForm.controls['earthing'].value === false
                        }">
                    <span> {{ "N" }}</span>
                  </div>
                </div>
              </div>
              <div class="flex flex-col">
                <label class="block text-white mb-2 opacity-80 text-xs" for="email">
                  {{ "light_arrester" | translate }}
                </label>
                <div class="flex flex-row flex-grow space-x-2">
                  <div
                    class="dark:bg-none px-4 py-[3px] dark:text-white rounded-xl border-solid border-[0.5px] border-gray-300 flex items-center space-x-2 cursor-pointer"
                    [ngClass]="{
                          'bg-dark-accent-secondary':
                            solarForm.controls['lighteningArrester'].value ===
                            true
                        }">
                    <span> {{ "Y" }}</span>
                  </div>
                  <div
                    class="dark:bg-none px-4 py-[3px] dark:text-white rounded-xl border-solid border-[0.5px] border-gray-300 flex items-center space-x-2 cursor-pointer"
                    [ngClass]="{
                          'bg-dark-accent-secondary':
                            solarForm.controls['lighteningArrester'].value ===
                            false
                        }">
                    <span> {{ "N" }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <label class="block text-white mb-2 opacity-80 text-xs" for="email">
                {{ "Installation Place" | translate }}
              </label>

              <div class="flex flex-row flex-grow md:space-x-3 items-center">
                <div class="w-1/2 justify-center items-center">
                  <input id="draft" class="peer/draft" type="radio" name="status" disabled [checked]="
                          solarForm.controls['installationPlace'].value === 1
                        " />
                  <label for="draft" class="text-white text-xs mb-5">Roof top</label>
                </div>

                <div class="w-1/2 justify-center items-center">
                  <input id="published" class="peer/published" type="radio" name="status" disabled [checked]="
                          solarForm.controls['installationPlace'].value === 2
                        " />
                  <label for="published" class="text-white text-xs mb-5">Ground Mounted</label>
                </div>
              </div>
            </div>
            <div></div>
            <div>
              <label class="block text-white mb-2 opacity-80 text-xs" for="email">
                {{ "Solar Bill Image" | translate }}
              </label>
              <div class="flex flex-row flex-grow md:space-x-2">
                <div
                  class="w-[100px] h-[100px] border border-solid border-gray-400 rounded-2xl bg-dark-gray-2 text-white flex justify-center">
                  <img [src]="
                          solarForm.controls['panelImage'].value
                            ? solarForm.controls['panelImage'].value
                            : '../../../../assets/svg/gallery.svg'
                        " alt="Gallery" [ngClass]="{
                          'w-[100px] h-[100px] rounded-2xl':
                            solarForm.controls['panelImage'].value,
                          'm-8': !solarForm.controls['panelImage'].value
                        }" ()="
                          solarForm.controls['panelImage'].value
                            ? displayImage(
                                solarForm.controls['panelImage'].value
                              )
                            : null
                        " />
                </div>
                <div
                  class="hidden w-1/4 border border-solid border-gray-400 rounded-2xl py-[8px] px-3 bg-dark-gray-2 text-white flex justify-center items-center text-xs">
                  {{ "upload" | translate }}
                  <img src="../../../../assets/svg/upload-fota.svg" class="mx-1" alt="Upload" />
                </div>
              </div>
            </div>
            <div>
              <label class="block text-white mb-2 opacity-80 text-xs" for="email">
                {{ "Purchase Bill Image" | translate }}
              </label>
              <div class="flex flex-row flex-grow md:space-x-2">
                <div
                  class="w-[100px] h-[100px] border border-solid border-gray-400 rounded-2xl bg-dark-gray-2 text-white flex justify-center">
                  <img [src]="
                          solarForm.controls['purchaseBillImage'].value
                            ? solarForm.controls['purchaseBillImage'].value
                            : '../../../../assets/svg/gallery.svg'
                        " alt="Gallery" [ngClass]="{
                          'w-[100px] h-[100px] rounded-2xl':
                            solarForm.controls['purchaseBillImage'].value,
                          'm-8': !solarForm.controls['purchaseBillImage'].value
                        }" (appClickableDirective)="
                          solarForm.controls['purchaseBillImage'].value
                            ? displayImage(
                                solarForm.controls['purchaseBillImage'].value
                              )
                            : null
                        " />
                </div>
                <div
                  class="hidden w-1/4 border border-solid border-gray-400 rounded-2xl py-[8px] px-3 bg-dark-gray-2 text-white flex justify-center items-center text-xs">
                  {{ "upload" | translate }}
                  <img src="../../../../assets/svg/upload-fota.svg" class="mx-1" alt="Upload" />
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="border-b border-gray-200">
              <div (appClickableDirective)="toggleExpansion()"
                class="w-full text-left focus:outline-none text-white cursor-default flex flex-row justify-between">
                <div class="flex flex-row space-x-8 mt-6">
                  <span>
                    Type of Solar Panels ({{
                    solarForm.controls.panels.length
                    }})</span>
                  @if(solarForm.controls.panels.length>0){
                  <app-chevron-up-icon class="text-white" />
                  } @else{

                  <app-chevron-down-icon class="text-white" />
                  }


                </div>
              </div>
              <div class="text-white">Distinct Capacity</div>
              @if(expanded){
              <div class="text-white p-4 bg-[#323841] rounded-lg mt-5" formArrayName="panels">
                <div *ngFor="
                        let panel of solarForm.controls.panels.controls;
                        let i = index
                      " [formGroupName]="i">
                  <div class="mb-1">
                    <span>Type of Panels {{ 1 + i }}</span>
                  </div>
                  <div class="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-3 gap-4 mt-4">
                    <div>
                      <mat-form-field appearance="outline">
                        <mat-label class="text-white text-xs">{{
                          "Brand" | translate
                          }}</mat-label>
                        <input class="text-white" formControlName="brand" matInput [id] ="'brand'" />
                      </mat-form-field>
                    </div>

                    <div>
                      <mat-form-field appearance="outline">
                        <mat-label class="text-white text-xs">{{
                          "Type" | translate
                          }}</mat-label>
                        <input class="text-white" formControlName="panelType" matInput [id] ="'type'" />
                      </mat-form-field>
                    </div>
                    <div>
                      <mat-form-field appearance="outline">
                        <mat-label class="text-white text-xs">{{
                          "Number of Panel" | translate
                          }}</mat-label>
                        <input class="text-white" formControlName="noofPanel" matInput [id] ="'noOfPanel'" />
                      </mat-form-field>
                    </div>
                    <div>
                      <mat-form-field appearance="outline">
                        <mat-label class="text-white text-xs">{{
                          "Capacity(Watt)" | translate
                          }}</mat-label>
                        <input class="text-white" formControlName="capacity" matInput  [id] ="'capacity'"/>
                      </mat-form-field>
                    </div>

                    <div>
                      <mat-form-field appearance="outline">
                        <mat-label class="text-white text-xs">V<sub>oc </sub>
                          {{ "Open Circuit Voltage " | translate }}
                        </mat-label>
                        <input class="text-white" formControlName="openCircuitVoltage" matInput [id] ="'openCircuit'" />
                      </mat-form-field>
                    </div>
                    <div>
                      <mat-form-field appearance="outline">
                        <mat-label class="text-white text-xs">
                          I<sub>oc </sub>
                          {{ "Short Circuit Voltage " | translate }}
                        </mat-label>
                        <input class="text-white" formControlName="shortCircuitCurrent" matInput [id] ="'shortCircuit'" />
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>}
            </div>
          </div>
          <div class="hidden col-span-6 flex justify-st items-center">
            <div class="flex justify-center items-center rounded-xl bg-dark-accent-secondary px-4 py-[5px] text-white">
              <span class="text-xs p-0">Save</span>
            </div>
          </div>
        </form>
        }
      </div>
      }
      <div class="content" [ngClass]="{ active: activeTab === plantDetailInformationType.dataLoggerDetails}">
        @if (activeTab === plantDetailInformationType.dataLoggerDetails) {
        <form [formGroup]="dataLoggerForm">
          <div class="grid grid-cols-1 lg:grid-cols-2 md:grid-cols-2 gap-4 mt-4">
            <div>
              <mat-form-field appearance="outline">
                <mat-label class="text-white text-xs">{{
                  "serial_number" | translate
                  }}</mat-label>
                <input class="text-white" formControlName="serialNo" matInput [id]="'serialNo'" />
              </mat-form-field>
            </div>

            <div>
              <mat-form-field appearance="outline">
                <mat-label class="text-white text-xs">{{
                  "firmware_version" | translate
                  }}</mat-label>
                <input class="text-white" formControlName="firmWareVersion" matInput [id]="'firmware'" />
              </mat-form-field>
            </div>
            <div>
              <mat-form-field appearance="outline">
                <mat-label class="text-white text-xs">{{
                  "connectivity_type" | translate
                  }}</mat-label>
                <input class="text-white" formControlName="connectivityType" matInput [id]="'wifiSignal'" />
              </mat-form-field>
            </div>

            <div>
              <mat-form-field appearance="outline">
                <mat-label class="text-white text-xs">{{
                  "installation_date" | translate
                  }}</mat-label>
                <input class="text-white" formControlName="installationDate" matInput [id]="'installationType'">
              </mat-form-field>
            </div>
            <div class="hidden">
              <mat-form-field appearance="outline">
                <mat-label class="text-white text-xs">{{
                  "wifi_signal" | translate
                  }}</mat-label>
                <input class="text-white" formControlName="connectivityType" matInput [id]="'wifiSignal'" />
              </mat-form-field>
            </div>
          </div>
          <div class="col-span-6 bg-[#2b3139] rounded-xl mb-6">
            <div class="flex flex-col py-2 h-full">
              <span class="px-4 text-[#94989E] sm:text-[14px] xl:text-xl">Today's Signal Strength</span>
              <div class="h-60">
                <div class="h-full flex flex-grow">
                  @if (
                  chartOptions &&
                  chartOptions.chart?.type &&
                  chartOptions.series &&
                  chartOptions.series.length > 0
                  ) {
                  <apx-chart class="w-full h-full" [series]="chartOptions.series!" [chart]="chartOptions.chart!"
                    [xaxis]="chartOptions.xaxis!" [yaxis]="chartOptions.yaxis!" [tooltip]="chartOptions.tooltip!"
                    [dataLabels]="chartOptions.dataLabels!" [stroke]="chartOptions.stroke!"
                    [plotOptions]="chartOptions.plotOptions!" [grid]="chartOptions.grid!"
                    [legend]="chartOptions.legend!"></apx-chart>
                  }@else {
                  <div class="w-full h-full flex items-center justify-center text-center">
                    <span class="text-[#94989E] sm:text-[14px] xl:text-lg ">
                      No Record Found
                    </span>

                  </div>
                  }
                </div>
              </div>
            </div>
          </div>
          <div class="hidden flex flex-col mb-5 col-span-2">
            <label class="block text-white mb-2 opacity-80 text-xs" for="email">
              {{ "wifi_configuration" | translate }}
            </label>
          </div>

          <div class="hidden flex flex-col mb-5 col-span-2">
            <label class="block text-blue-400 mb-2 opacity-80 text-xs m-0" for="email">
              Luminous_IOT_Wifi_xxxx
            </label>
            <div class="flex flex-col md:flex-row flex-grow md:space-x-2">
              <span class="text-xs opacity-80 m-0">{{
                "connected" | translate
                }}</span>
            </div>
          </div>
        </form>
        }
      </div>
      <div class="content" [ngClass]="{ active: activeTab === plantDetailInformationType.connectedUser}">
        @if (activeTab === plantDetailInformationType.connectedUser) {
        <!-- Connected User Content -->
        <div class="p-4">
          <div>
            <span class="dark:text-white text-sm opacity-40">{{
              "primary_users" | translate
              }}</span>
            @if (connectedUsersData?.primaryUser) {
            <div class="flex flex-row justify-start items-center space-x-2 mt-4">
              <img src="../../../../assets/svg/default-user.svg" alt="avator" class="w-9 h-9" alt="Avator" />
              <span class="dark:text-blue-500 text-[12px]">{{
                connectedUsersData?.primaryUser?.userName
                }}</span>
            </div>
            }
          </div>
          <div class="mt-4">
            <span class="dark:text-white text-sm opacity-40 my-4 ">{{
              "secondary_users" | translate
              }}</span>

            @if (connectedUsersData?.seocndaryUsers) {
            @for (
            item of connectedUsersData?.seocndaryUsers;
            track $index
            ) {
            <div class="flex flex-row justify-between items-center space-x-2 mt-4">
              <div class="flex flex-row items-center space-x-2">
                <img src="../../../../assets/svg/default-user.svg" class="w-9 h-9" alt="Avator" />
                <div class="flex flex-col leading-tight">
                  <span class="dark:text-blue-500 text-[12px]">{{
                    item.userName
                    }}</span>
                  @if (isPrimaryUser) {
                  <span class="label-xs ml-0 text-white opacity-60">{{
                    item.email ?? ""
                    }}</span>
                  }
                </div>
              </div>
              @if (isPrimaryUser) {
              <div class="rounded-xl px-3 py-[2px] text-white border border-solid border-gray-400 cursor-default"
                (appClickableDirective)="removeUser(item)">
                <span class="text-xs p-0">{{
                  "remove" | translate
                  }}</span>
              </div>
              }
            </div>
            }
            }
            <a routerLinkActive="active" [routerLink]="['../../add-secondary-user']"
              [queryParams]="{ plantId: plantData?.id }">
              <div class="flex flex-col mt-5 col-span-2">
                <div class="flex flex-col md:flex-row flex-grow md:space-x-2">
                  @if (isPrimaryUser) {
                  <div
                    class="border border-solid border-gray-400 rounded-2xl py-[8px] px-3 text-white bg-dark-gray-2 flex justify-center items-center">
                    <div class="rounded-full bg-blue-500 mr-2 w-5 h-5 flex justify-center items-center">
                      <app-plus-icon class="color-white" />
                    </div>
                    {{ "Add User" | translate }}
                  </div>
                  }
                </div>
              </div>
            </a>
          </div>
        </div>
        }
      </div>

      @if (isPrimaryUser) {
      <div class="content" [ngClass]="{ active: activeTab ===plantDetailInformationType.downloadReport}">
        @if (activeTab ===plantDetailInformationType.downloadReport) {
        <div class="flex justify-center items-center mt-20">
          <div class="w-full h-full">
            <form [formGroup]="radioForm">
              <div class="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 gap-4 mt-4">
                <div *ngFor="let option of options" class="col-span-1 justify-center items-center">
                  <input type="radio" [value]="option" formControlName="selectedOption" [id]="downloadReport" />
                  <span class="text-white text-sm ms-2">{{
                    option.value
                    }}</span>
                </div>
              </div>
            </form>
            <div class="flex mt-32">
              <div
                class="flex justify-center items-center rounded-xl bg-dark-accent-secondary hover:opacity-80 px-4 py-[10px] text-white cursor-default"
                (appClickableDirective)="downloadReport()">
                <span class="text-xs p-0">{{
                  "send_to_email" | translate
                  }}</span>
              </div>
            </div>
          </div>
        </div>
        }
      </div>
      }
    </div>
  </div>
</div>